import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-report-public-badge',
  templateUrl: './report-public-badge.component.html',
  styleUrls: ['./report-public-badge.component.scss'],
  host: { 'class': 'badge' }
})
export class ReportPublicBadgeComponent {
  @Input() public link: string;
}
